import user from './user';
import feedback from './feedback';
import gameState from './gameState';
import gameStateInput from './gameStateInput';
import popup from './popup';
import project from './project';
import schoolClass from './schoolClass';
import group from './group';
import policyChoice from './policyChoice';
import ghettoRadio from './ghettoRadio';
import bankNotification from './bankNotification';
import timer from './timer';

export default {
  user,
  feedback,
  gameState,
  project,
  schoolClass,
  group,
  gameStateInput,
  popup,
  policyChoice,
  ghettoRadio,
  bankNotification,
  timer,
};

export {
  user,
  feedback,
  gameState,
  project,
  schoolClass,
  group,
  gameStateInput,
  popup,
  policyChoice,
  ghettoRadio,
  bankNotification,
  timer,
};



// WEBPACK FOOTER //
// ./src/actions/index.js